import { connect } from 'react-redux';
import { streamActions, mediaSelectors, currentUserSelectors } from '@lifesize/nucleus';
import { FIRST_TIME_USER_SETTING } from 'constants/UserSettings';
import { saveAudioMuted } from 'actions/SettingsModal';
import SourceDisplay from 'components/SourceDisplay/SettingsSourceDisplay';
import _get from 'lodash/get';

const mapStateToProps = (state) => {
  const videoDevices = mediaSelectors.videoDevices(state) || [];
  const audioDevices = mediaSelectors.audioDevices(state) || [];
  const audioOutputDevices = mediaSelectors.audioOutputDevices(state) || [];

  const defaultVideoSetting = true;
  const defaultAudioSetting = _get(state, 'app.settingsModal.defaultAudioSetting');
  const selectedVideoSource = mediaSelectors.selectedVideoDevice(state);
  const selectedAudioSource = mediaSelectors.selectedAudioDevice(state);
  const selectedAudioOutputDevice = mediaSelectors.selectedAudioOutputDevice(state);

  let selectedVideoLabel = selectedVideoSource ? selectedVideoSource.label : null;
  if (!selectedVideoLabel) {
    selectedVideoLabel = videoDevices.length ? videoDevices[0].label : '';
  }

  let selectedAudioLabel = selectedAudioSource ? selectedAudioSource.label : null;
  if (!selectedAudioLabel) {
    selectedAudioLabel = audioDevices.length ? audioDevices[0].label : '';
  }

  let selectedAudioOutputLabel = selectedAudioOutputDevice ? selectedAudioOutputDevice.label : null;
  if (!selectedAudioOutputLabel) {
    selectedAudioOutputLabel = audioOutputDevices.length ? audioOutputDevices[0].label : '';
  }

  return {
    videoDevices,
    audioDevices,
    defaultVideoSetting,
    defaultAudioSetting,
    selectedVideoLabel,
    selectedAudioLabel,
    selectedAudioOutputLabel,
    isAcquiringPrimaryStream: _get(state, 'nucleus.media.isAcquiringPrimaryStream'),
    firstTimeUser: _get(currentUserSelectors.myInfo(state), ['userSettings', FIRST_TIME_USER_SETTING])
  };
};

const mapDispatchToProps = dispatch => ({
  acquireLocalPrimaryStream: () => {
    dispatch(streamActions.acquireLocalPrimaryStream({ audio: true, video: true }));
  },
  endLocalStream: () => dispatch(streamActions.endLocalStream()),
  selectVideoSource: (id) => {
    dispatch(streamActions.setPrimaryVideoSourceId(id));
    dispatch(streamActions.acquireLocalPrimaryStream({ audio: true, video: true }));
  },
  selectAudioSource: (id) => {
    dispatch(streamActions.setPrimaryAudioSourceId(id));
    dispatch(streamActions.acquireLocalPrimaryStream({ audio: true, video: true }));
  },
  selectAudioOutput: (id) => { dispatch(streamActions.setPrimaryAudioOutputId(id)); },
  setVideoEnabledDefault: (toggle) => { dispatch(streamActions.setVideoEnabledDefault(toggle)); },
  setAudioEnabledDefault: (toggle) => { dispatch(streamActions.setAudioEnabledDefault(toggle)); },
  toggleAudioMuteSetting: toggle => dispatch(saveAudioMuted(toggle))
});

const mergeProps = (stateProps, dispatchProps) => (
  Object.assign({}, stateProps, dispatchProps,
    {
      acquireLocalPrimaryStream: permissionPromise =>
        dispatchProps.acquireLocalPrimaryStream(
          permissionPromise,
          stateProps.defaultAudioSetting,
          stateProps.firstTimeUser
        )
    })
);

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(SourceDisplay);
